import React from 'react';
import AppContent from './app_contents/app_content';
import Banner from './banner/banner';

const Main = () => {
    return (
        <div>
            <Banner/>
            <AppContent/>
        </div>
    );
};

export default Main;